import {Component} from "@angular/core";
import {CurrentBusinessService} from "../../../services/communication/currentBusinessService";

@Component({
  selector: 'payment-success',
  template: require('./payment-success.component.html'),
  styles: [
    require('./payment-success.component.scss')
  ]
})
export class PaymentSuccessComponent {

  constructor(private currentBusiness: CurrentBusinessService) {
    this.currentBusiness.reloadBusiness();
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/payment/success/payment-success.component.ts